import React from "react";
import { BgWrapper } from "src/components/CaseLayout/Team/styles";
import { Name } from "src/components/CaseLayout/Team/styles";
import { TeamText } from "src/components/CaseLayout/Team/styles";
import { TeamImage } from "src/components/CaseLayout/Team/styles";
import { TeamWrapper } from "src/components/CaseLayout/Team/styles";
import { TeamSection } from "src/components/CaseLayout/Team/styles";
import { SmallTitle } from "src/components/CaseLayout/Team/styles";
import { TeamItem, Position } from "src/components/CaseLayout/Team/styles";

export const Team = ({ data, swap, columns = 4 }) => (
  <BgWrapper>
    <TeamSection>
      <SmallTitle>Zespół</SmallTitle>
      <TeamWrapper>
        {data.map((item, i) => (
          <TeamItem key={i} columns={columns}>
            {item.image && <TeamImage>{item.image}</TeamImage>}
            <TeamText swap={swap}>
              <Position>{item.position}</Position>
              <Name>{item.name}</Name>
            </TeamText>
          </TeamItem>
        ))}
      </TeamWrapper>
    </TeamSection>
  </BgWrapper>
)
